/**
 * AppSwitch — presentational MUI Switch wrapper with an inline label.
 *
 * Renders as `role="switch"` (MUI Switch's native role) — tests must query it
 * that way, NOT `role="checkbox"`.
 */
import type { Ref } from 'react';
import { FormControlLabel, Switch } from '@mui/material';

interface AppSwitchProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Native tooltip — for a switch whose label has no room for help text. */
  title?: string | undefined;
  /** The switch input, so a reveal control can move focus onto it. */
  inputRef?: Ref<HTMLInputElement>;
}

export function AppSwitch({
  label,
  checked,
  onChange,
  disabled = false,
  title,
  inputRef,
}: AppSwitchProps) {
  return (
    <FormControlLabel
      title={title}
      control={
        <Switch
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          disabled={disabled}
          {...(inputRef ? { slotProps: { input: { ref: inputRef } } } : {})}
        />
      }
      label={label}
    />
  );
}
